import { Component, OnInit, Input, OnDestroy }   from '@angular/core';
import { Response, URLSearchParams }      from '@angular/http';

import { ApiService }                     from '../../root-services/api.service';

// RxJs Interfaces
import { ISubscription }                  from 'rxjs/Subscription';

import { AnalyticsService }               from './../../analytics/analytics.service';
import { EditionService }                  from '../services/edition.service';

@Component({
  selector: 'app-individual-stats',
  templateUrl: './individual-stats.component.html',
  styleUrls: ['./individual-stats.component.less']
})
export class IndividualStatsComponent implements OnInit, OnDestroy {
  @Input() id: number;
  @Input() stateObj: any;
  @Input() groupObj: any;
  public data: any = null;
  private learningTimeData: any = null;
  private completionData: any = null;
  private days = 0;
  private selectedQuizFm: any = null;
  private graphMin = 0;
  private getLearningTimeJSONObservable: ISubscription;
  private getCompletionPercentageJSONObservable: ISubscription;
  private getIndividualJSONObservable: ISubscription;

  constructor(
    private api: ApiService,
    private analytics: AnalyticsService,
    private editionService: EditionService
  ) {}

  ngOnInit() {
    this.loadData();
  }

  ngOnDestroy() {
    if (this.getLearningTimeJSONObservable) this.getLearningTimeJSONObservable.unsubscribe();
    if (this.getCompletionPercentageJSONObservable) this.getCompletionPercentageJSONObservable.unsubscribe();
    if (this.getIndividualJSONObservable) this.getIndividualJSONObservable.unsubscribe();
  }

  private loadData() {
    //console.log('loading data for ', this.id, ' with context ', this.stateObj['categoryType'], ' ', this.stateObj['categoryId']);
    this.getIndividualJSONObservable = this.api.get(this.getIndividualUrl())
      .map((response: Response) => response.json())
      .subscribe(data => {
         this.data = data;
         // Set initially selected quiz to first available
         if (data.quizzes.length) {
            this.selectedQuizFm = data.quizzes[0].fms[0];
         }
         console.log(data);
      });
    this.loadGraphData();
  }

  private loadGraphData() {
    let categoryType: string, categoryId: string;
    if (this.stateObj) {
        categoryType = this.stateObj.categoryType;
        categoryId = this.stateObj.categoryId;
    } else if (this.groupObj) {
        categoryType = 'group';
        categoryId = this.groupObj.id;
    }
    let graphStateObj = {
      graphType: `individual/${this.id}/learning_time`,
      categoryType: categoryType,
      categoryId: categoryId
    }
    this.getLearningTimeJSONObservable = this.analytics.getGraphJSON({
            stateObj: graphStateObj,
            numberOfDays: this.days,
            liveFilterRef: 'all'
          })
        .subscribe(dataset => this.learningTimeData = dataset);
    if (this.stateObj || this.groupObj) {
        graphStateObj.graphType = 'individual/' + this.id + '/completion';
        this.getCompletionPercentageJSONObservable = this.analytics.getGraphJSON({
            stateObj: graphStateObj,
            numberOfDays: this.days,
            liveFilterRef: 'all'
          })
          .subscribe(dataset => this.completionData = dataset);
    }
  }

  private getIndividualUrl(extraPath?: string, days?: number): string {
    let url = `/analytics/individual/${this.id}`;
    if (extraPath) {
      url += extraPath;
    }
    let params = new URLSearchParams();
    if (this.groupObj) {
      params.set('group_id', this.groupObj.id);
    }
    else if (this.stateObj && this.stateObj['categoryType'] !== 'edition') {
      params.set(this.stateObj['categoryType'] + '_id', this.stateObj['categoryId']);
    }
    if (days) {
      params.set('days', days.toString());
    }
    let querystring = params.toString();
    if (querystring.length) {
      url += '?' + querystring;
    }
    return url;
  }

  public gotoProfile(userId: number): boolean {
    let path = `/profile/${userId}`;
    this.editionService.jumpToLearning(path);
    return false;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/individual-stats/individual-stats.component.ts